import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.FormDatePicker,
  title: 'Date Picker',
  category: ComponentCategory.FormControls,
};
